import { jsx as _jsx } from "react/jsx-runtime";
import { selectedItemsSelector } from "@air/redux-selected-items";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { GalleryItemType } from "~/components/Gallery/types";
import { DownloadButton } from "~/components/v2/components/shared/selectionBar/DownloadButton";
import { ShareButton } from "~/components/v2/components/shared/selectionBar/ShareButton";
import { useGetPublicAssetMenuOptionsCallback } from "~/components/v2/hooks/useGetPublicAssetMenuOptionsCallback";
import { useGetPublicBoardMenuOptionsCallback } from "~/components/v2/hooks/useGetPublicBoardMenuOptionsCallback";
import { usePublicSelectionMenuOptions } from "~/components/v2/hooks/usePublicSelectionMenuOptions";
import { selectedBoardsSelector, selectedFileClipsSelector, selectedMediaClipsSelector } from "~/store/selectedItems/selectors";
export const usePublicSelectionBarMenu = (param)=>{
    let { canDownload, canDownloadAsset, handleBulkDownload, handleBoardDownload, handleBoardShare, handleAssetDownload, handleClipShare } = param;
    // Selectors
    const selectedItems = useSelector(selectedItemsSelector);
    const selectedBoardItems = useSelector(selectedBoardsSelector);
    const selectedMediaClipItems = useSelector(selectedMediaClipsSelector);
    const selectedFileItems = useSelector(selectedFileClipsSelector);
    // Menu options callbacks
    const { getBoardMenuOptionsCallback } = useGetPublicBoardMenuOptionsCallback();
    const { getAssetMenuOptionsCallback } = useGetPublicAssetMenuOptionsCallback();
    const { getSelectionMenuOptions } = usePublicSelectionMenuOptions();
    return useMemo(()=>{
        let options = getSelectionMenuOptions("action-bar", true);
        let downloadButton = canDownload ? /*#__PURE__*/ _jsx(DownloadButton, {
            hasMultiple: selectedItems.length > 1,
            onClick: handleBulkDownload
        }) : null;
        let shareButton = null;
        // Handle single item selection
        if (selectedItems.length === 1) {
            const selectedItem = selectedItems[0];
            if (selectedItem.type === GalleryItemType.board) {
                const board = selectedBoardItems[0];
                options = getBoardMenuOptionsCallback({
                    item: board
                })({
                    trackLocation: "action-bar"
                });
                downloadButton = canDownload ? /*#__PURE__*/ _jsx(DownloadButton, {
                    hasMultiple: false,
                    onClick: ()=>handleBoardDownload(board.id)
                }) : null;
                shareButton = /*#__PURE__*/ _jsx(ShareButton, {
                    onClick: ()=>handleBoardShare(board)
                });
            } else if (selectedItem.type === GalleryItemType.asset) {
                const clip = selectedMediaClipItems[0];
                options = getAssetMenuOptionsCallback({
                    item: clip
                })({
                    trackLocation: "action-bar"
                });
                downloadButton = canDownloadAsset ? /*#__PURE__*/ _jsx(DownloadButton, {
                    hasMultiple: false,
                    onClick: ()=>handleAssetDownload(clip.id)
                }) : null;
                shareButton = /*#__PURE__*/ _jsx(ShareButton, {
                    onClick: ()=>handleClipShare(clip.id)
                });
            } else if (selectedItem.type === GalleryItemType.file) {
                const file = selectedFileItems[0];
                options = getAssetMenuOptionsCallback({
                    item: file
                })({
                    trackLocation: "action-bar"
                });
                downloadButton = canDownloadAsset ? /*#__PURE__*/ _jsx(DownloadButton, {
                    hasMultiple: false,
                    onClick: ()=>handleAssetDownload(file.id)
                }) : null;
                shareButton = /*#__PURE__*/ _jsx(ShareButton, {
                    onClick: ()=>handleClipShare(file.id)
                });
            }
        }
        return {
            menuOptions: options,
            SuffixBarButtons: [
                downloadButton,
                shareButton
            ]
        };
    }, [
        getSelectionMenuOptions,
        canDownload,
        selectedItems,
        handleBulkDownload,
        selectedBoardItems,
        getBoardMenuOptionsCallback,
        handleBoardDownload,
        handleBoardShare,
        selectedMediaClipItems,
        getAssetMenuOptionsCallback,
        canDownloadAsset,
        handleAssetDownload,
        handleClipShare,
        selectedFileItems
    ]);
};
